Ext.define('WindowStartManualTankTramwaje', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.start_manual_proces_tankowania.capitalise(),
    width: 550,
    closable: false,
    collapsible: false,
    scrollable: false,
    modal: true,
    resizable: false,
    layout: 'fit',
    pojazdstore: null,
    initComponent: function () {
        this.cid = Ext.id();
        this.pojazdstore = Ext.create('Ext.data.Store', {
            fields: ['id', 'nazwa'],
            proxy: {
                type: 'ajax',
                url: 'rest/tramwaje/getPojazdForManualStartList',
                actionMethods: {
                    read: 'POST'
                },
                reader: {
                    type: 'json',
                    rootProperty: 'data'
                }
            },
            autoLoad: true
        })
        this.items = [{
            xtype: 'panel',
            layout: 'column',
            items: [{
                columnWidth: 1,
                xtype: 'form',
                id: this.cid + 'formpanel',
                bodyStyle: 'padding:10px 10px 10px 10px',
                scrollable: false,
                defaults: {
                    labelWidth: 150,
                    labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left',
                    anchor: "0"
                },
                items: [{
                    id: this.cid + "pojazd",
                    name: "pojazd",
                    fieldLabel: Lang.pojazd,
                    allowBlank: false,
                    xtype: "comboexd",
                    minChars: 1,
                    editable: true,
                    store: this.pojazdstore,
                    displayField: 'nazwa',
                    valueField: 'id',
                    forceSelection: true,
                    emptyText: '...'
                }, {
                    id: this.cid + "tor",
                    name: "tor",
                    fieldLabel: Lang.tor,
                    allowBlank: false,
                    xtype: "comboexd",
                    minChars: 1,
                    editable: true,
                    store: Ext.create('Ext.data.Store', {
                        fields: ['value'],
                        proxy: {
                            type: 'ajax',
                            url: 'rest/tramwaje/getTorForManualStartList',
                            actionMethods: {
                                read: 'POST'
                            },
                            reader: {
                                type: 'json',
                                transform: function (data) {
                                    return {
                                        data: data.map(function (item) {
                                            return {value: item};
                                        })
                                    };
                                },
                                rootProperty: 'data'
                            }
                        },
                        autoLoad: true
                    }),
                    displayField: 'value',
                    valueField: 'value',
                    forceSelection: true,
                    emptyText: '...'
                }, {
                    id: this.cid + "durationinmin",
                    name: "durationinmin",
                    xtype: 'numberfield',
                    fieldLabel: Lang.czas_trwania_w_minutach,
                    allowBlank: false,
                    blankText: Lang.pole_nie_moze_byc_puste,
                    value: 15,
                    minValue: 1
                }, {
                    id: this.cid + "podwojnysklad",
                    name: "podwojnysklad",
                    xtype: 'checkboxexd',
                    fieldLabel: Lang.podwojny_sklad,
                    value: false,
                    listeners: {
                        scope: this,
                        change: function (field, newValue, oldValue) {
                            Ext.getCmp(this.cid + "pojazd2").setDisabled(!newValue);
                            Ext.getCmp(this.cid + "pojazd2").allowBlank = !newValue;
                        }
                    }
                }, {
                    id: this.cid + "pojazd2",
                    name: "pojazd2",
                    fieldLabel: Lang.pojazd + " 2",
                    xtype: "comboexd",
                    minChars: 1,
                    editable: true,
                    disabled: true,
                    store: this.pojazdstore,
                    displayField: 'nazwa',
                    valueField: 'id',
                    forceSelection: true,
                    emptyText: '...'
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'start',
            text: Lang.start,
            scope: this,
            handler: this.startOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function () {
        if (!validPrivilegesOperatorComplex(ViewTramwaje.accessPropertyName)) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.show();
        this.center();
    },
    startOp: function () {
        if (!validPrivilegesOperatorComplex(ViewTramwaje.accessPropertyName)) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        if (false === Ext.getCmp(this.cid + 'formpanel').getForm().isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }
        sendAjaxDataJsonRpcL("rest/tramwaje/startManualTankTramwaje", {
            pojazd: Ext.getCmp(this.cid + "pojazd").getValue(),
            tor: Ext.getCmp(this.cid + "tor").getValue(),
            durationinmin: Ext.getCmp(this.cid + "durationinmin").getValue(),
            podwojnysklad: Ext.getCmp(this.cid + "podwojnysklad").getValue(),
            pojazd2: Ext.getCmp(this.cid + "pojazd2").getValue()
        }, this, function (data) {
            if (data.status) {
                this.closeOp();
                Ext.MessageBox.alert(Lang.operacja, Lang.operacja_zakonczona_poprawnie);
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    closeOp: function () {
        this.close();
    }
});
